import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import IconTextButton from '@/components/ui/IconTextButton';
import ViewsEditorTabItemFolder from '@/components/viewseditor/ViewsEditorTabItemFolder';
import ViewsEditTemplate from '@/components/viewseditor/ViewsEditTemplate';
import ContentEditPage from '@/components/contenteditor/ContentEditPage';
import ContentEditFolder from '@/components/contenteditor/ContentEditFolder';

Vue.config.productionTip = false;

// ----------------------------------
//	AI custom components
// ----------------------------------

Vue.component('icon-text-button', IconTextButton);
Vue.component('views-editor-tab-item-folder', ViewsEditorTabItemFolder);
Vue.component('views-edit-template', ViewsEditTemplate);
Vue.component('content-edit-page', ContentEditPage);
Vue.component('content-edit-folder', ContentEditFolder);


// ----------------------------------
//	AI event bus
// ----------------------------------

export const AiEventBus = new Vue();


// ----------------------------------
//	Setup Vue
// ----------------------------------

new Vue
({
	router,
	vuetify,
	render: h => h(App),

	data: () =>
	({
		
	}),

	created: () =>
	{
		window.$vuetify = vuetify.framework;
	},

	computed:
	{

	},

})
.$mount('#app')